export default __webpack_public_path__ + "coupons-icon.png";